import Vue from 'vue';
import './vant';
import { alert, confirm } from '@/utils/dialog';

Vue.use(require('./title').default);

Vue.prototype.$alert = alert;
Vue.prototype.$confirm = confirm;
